import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AssetStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-assetstatus',
  templateUrl: './assetstatus.component.html',
  styleUrls: ['./assetstatus.component.scss']
})
export class AssetstatusComponent implements OnChanges {

  assetStatusForm: FormGroup;
  assetStatusFormArray: FormGroup;
  control = new FormControl();
  @Input() assetStatuss: AssetStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() assetStatus = new EventEmitter<AssetStatusDto[]>()
  @Output() deleteAssetStatusEvent = new EventEmitter<any>()

    selectedAssetStatus: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createAssetStatusForm();
    }

    createAssetStatusForm() {
      this.assetStatusForm = this.fb.group({
        AssetStatusName: ['', Validators.required],
        id: null
        });
        this.assetStatusFormArray = this.fb.group({ AssetStatuss: this.fb.array([])
          });
        this.setAssetStatus();
    }

  // method to display assetStatus
  setAssetStatus() {
    const control  = this.assetStatusFormArray.controls.AssetStatuss as FormArray;
    this.assetStatuss.forEach( e => {
      control.push(
        this.fb.group({
          AssetStatusName: e.AssetStatusName,
          id: e.id
        })
      );
    });
  }


  // method to add assetStatus
  addAssetStatus(value: AssetStatusDto) {
    const control  = this.assetStatusFormArray.controls.AssetStatuss as FormArray;
    control.insert(0,
          this.fb.group({
            AssetStatusName: value.AssetStatusName,
            id: null
          })
       );
  }

  selectAssetStatus(value) {}

  // method to delete assetStatus from arrary list
  deleteAssetStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.assetStatusFormArray.controls.AssetStatuss as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.assetStatuss.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.assetStatuss[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: AssetStatusDto) {
    if(this.assetStatusForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.assetStatusFormArray.get('AssetStatuss')['controls'][this.selectedIndex].patchValue({AssetStatusName: formValue.AssetStatusName});
    } else {
      this.addAssetStatus(formValue);
    }
    this.selectedIndex = null;
    this.assetStatusForm.reset()
  }

  onEdit(index, value: AssetStatusDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.assetStatusForm.patchValue({AssetStatusName: value.AssetStatusName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.assetStatusForm.reset();
  }

  onSubmit(formValue: AssetStatusDto[]) {
  this.assetStatus.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteAssetStatusEvent.emit(this.filteredDelete);
  }
  }

}
